// Blocking

/**
 * @module reducers-blocking
 * @desc (State/Reducers) These reducers manage changing the Blocking state
 * @prop {object} markedWords - Index of line numbers and word numbers, denoting marked words.
 * @prop {function} markedOffset - Array of words offset for the following line, used for spacing when made hidden.
 * @prop {object} hover - two props, line and word, both numbers of the currently hovered word.
 * @prop {boolean} saved - whether or not a save has occurred (still needs work)
 */

export default
function blocking(state = {
  markedWords: {},
  markedOffset: [],
  hover : {line: null, word: null},
  saved: false
}, action) {
  switch(action.type) {
    case 'ADD_MARKED':
      return Object.assign({}, state, {
        markedWords: action.markedWords,
        markedOffset: state.markedOffset.concat(action.markedOffset),
        saved: false
      });
    case 'REMOVE_MARKED':
      return Object.assign({}, state, {
        markedWords: action.markedWords,
        saved: false
      });
    case 'CALCULATE_BLOCKS':
      return Object.assign({}, state, {
        blockedLines: action.blockedLines
      });
    case 'TOGGLE_HOVER':
      return Object.assign({}, state, {
        hover: action.index
      });
    case 'UPDATE_BLOCKS':
      return Object.assign({}, state, {
        saved: true
      });
    case 'RESET_BLOCKS':
      return Object.assign({}, state, {
        markedWords: {}, markedOffset: [], hover: {line: null, word: null}
      });
    case 'LOAD_MARKED':
      return Object.assign({}, state, {
        markedWords: action.markedWords,
        markedOffset: action.markedOffset
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/blocking.js